import { Layout as AntLayout } from "antd";
import styled from "styled-components";

export const Layout = styled(AntLayout)`
  height: 100%;
  background-color: var(--velotax-background-color-ghost);
  &.showIrpfBanner {
    height: calc(100% - 80px);
  }
  .content {
    &.overflow {
      overflow-y: auto;
    }
  }
`;
